/** @file Reads skins into slot -> placeholder id -> attachment index maps, interning placeholders. */
import type { Pose2DJson } from '@pose2d/format/types';
import type { SkinData } from '../../skeletonData';
import type { Interner } from './createInterner';
import { indexIn } from './indexIn';

/** Skins in rig order; slot and attachment indices are checked (VALIDATION at `skins[i].map[k]`). */
export function readSkins(skins: Pose2DJson['skins'], slotCount: number, attachmentCount: number, placeholders: Interner): SkinData[] {
  return skins.map((skin, i): SkinData => {
    const map = new Map<number, Map<number, number>>();
    skin.map.forEach(([slot, placeholder, attachment], k) => {
      const path = `skins[${i}].map[${k}]`;
      const s = indexIn(slot, slotCount, path);
      const bySlot = map.get(s) ?? new Map<number, number>();
      bySlot.set(placeholders.intern(placeholder), indexIn(attachment, attachmentCount, path));
      map.set(s, bySlot);
    });
    return { name: skin.name, map };
  });
}
